import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import ContactSection from '../components/sections/ContactSection';

const ContactPage = () => {
  const { t } = useTranslation();
  const { currentLang } = useLanguage();

  useEffect(() => {
    document.title = currentLang === 'ar'
      ? 'تواصل معنا | أرمان كيتشنز'
      : 'Contact Us | Arman Kitchens';
  }, [currentLang]);

  return (
    <main data-testid="contact-page" className="pt-24">
      {/* Hero Banner */}
      <section className="relative h-[40vh] min-h-[300px] flex items-center">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1527501034545-bbadafbf308b)' }}
        />
        <div className="absolute inset-0 bg-black/60" />
        <div className="container-custom relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <span className="label-text mb-4 block">{t('contact.label')}</span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white">
              {currentLang === 'ar' ? 'تواصل معنا' : 'Contact Us'}
            </h1>
          </motion.div>
        </div>
      </section>

      <ContactSection />
    </main>
  );
};

export default ContactPage;
